import BaseLevelScene from './BaseLevelScene';

export default class PumpHouseScene extends BaseLevelScene {
  tileWidth: integer = 16;
  tileHeight: integer = 16;
  constructor() {
    super('PumpHouseLevel2');
  }

  preload() {

    // Preload base level
    this.preloadBaseLevel();

    // load the PNG file
    this.load.image('sewer_tiles', 'assets/sourceImages/sewer_extruded.png');

    // load the JSON file
    this.load.tilemapTiledJSON(
      'pump_house_tilemap_l2',
      'assets/scenes/PumpHouseLevel2.json'
    );
  }

  create() {
    // 👌 sanity check by displaying the entire tileset image
    // this.add.image(0, 0, 'sewer_tiles');

    // create the Tilemap
    this.map = this.make.tilemap({ key: 'pump_house_tilemap_l2' });

    // add the tileset image we are using
    const tileset = this.map.addTilesetImage('sewer', 'sewer_tiles');

    // create the layers we want in the right order
    const floor = this.map.createLayer('BaseLayer', tileset);
    this.map.setCollisionByProperty({collides: true});
    this.matter.world.convertTilemapLayer(floor);

    // "Ground" layer will be on top of "Background" layer
    const textures = this.map.createLayer('Textures', tileset);
    this.map.setCollisionByProperty({collides: true});
    this.matter.world.convertTilemapLayer(textures);

    // create base level
    this.createBaseLevel(0.4, 4);
  }
}
